import {BrowserRouter, Route, Routes} from "react-router-dom";
import {useEffect, useState} from "react";
import {toast, ToastContainer} from "react-toastify";

// import CourseList from "./test/modules/course/CourseList";
// import CourseDetail from "./test/modules/course/CourseDetail";
// import HeaderTest from "./test/shared/layout/header/HeaderTest";
// import HomeTest from "./test/modules/home/HomeTest";
// import DataViewDemo from "./test/modules/demo/DataViewDemo";
// import Header from "./test/shared/layout/header2/Header";
// import Showcase from "./test/shared/showcase/Showcase";
// import BasicDemo from "./test/modules/demo/BasicDemo";

import Home from "./pages/Home/Home";
import Course from "./pages/Course/Course";
import CourseView from "./pages/CourseView/CourseView";
import MyCourses from "./pages/User/MyCourses";
import CategoryCourses from "./pages/CategoryCourses/CategoryCourses";
import Login from "./pages/Login/Login";
import Profile from "./pages/User/Profile";
import InstructorInfo from "./pages/Instructor/InstructorInfo";
import Signup from "./pages/Signup/Signup";


import ChatGPT from "./pages/AI/ChatGPT/ChatGPT";
import InstructorHome from "./pages/Instructor/InstructorHome/InstructorHome";
import InstructorCourses from "./pages/Instructor/InstructorCourses/InstructorCourses";
import CreateCourse from "./pages/Instructor/CreateCourse/CreateCourse";
import CourseStudents from "./pages/Instructor/CourseStudents/CourseStudents";
import FileManager from "./pages/FileManager/FileManager";

import GeneralUtils from "./utils/GeneralUtils";
import {LoginService} from "./service/LoginService";

import InstructorHeader from "./components/header/InstructorHeader";


import {MouseMoveProvider} from "./contexts/mouse-move-context";

import sal from 'sal.js';
import Footer from "./layout/footers/footer";
import Header from "./components/header/Header";
import ScrollToTop from "./ui/scroll-to-top";
import Activation from "./pages/Login/Activation";
import LoadingProvider, {onHideLoading, onShowLoading} from "./components/loading/LoadingProvider";
import {AUTHORIZATION_HEADER} from "./utils/Constants";
import { jwtDecode } from "jwt-decode";
import {AppAiPanelExample} from "./pages/AI/AppAiPanelExample";
import Copilot from "./pages/AI/Copilot/Copilot"; // Copilot entegrasyonu


import { addLocale, locale as setPRLocale } from 'primereact/api';

if (typeof window !== 'undefined') {
    require( 'bootstrap/dist/js/bootstrap' );
}


// PrimeReact Calendar Turkish locale
addLocale('tr', {
    firstDayOfWeek: 1,
    dayNames: ['Pazar', 'Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi'],
    dayNamesShort: ['Paz', 'Pzt', 'Sal', 'Çar', 'Per', 'Cum', 'Cmt'],
    dayNamesMin: ['Pz', 'Pt', 'Sa', 'Ça', 'Pe', 'Cu', 'Ct'],
    monthNames: ['Ocak', 'Şubat', 'Mart', 'Nisan', 'Mayıs', 'Haziran', 'Temmuz', 'Ağustos', 'Eylül', 'Ekim', 'Kasım', 'Aralık'],
    monthNamesShort: ['Oca', 'Şub', 'Mar', 'Nis', 'May', 'Haz', 'Tem', 'Ağu', 'Eyl', 'Eki', 'Kas', 'Ara'],
    today: 'Bugün',
    clear: 'Temizle',
    weekHeader: 'Hf',
    dateFormat: 'dd.mm.yy'
});
setPRLocale('tr');

const App =()=> {
    const [isAuthenticated, setIsAuthenticated] = useState(localStorage.getItem("isAuthenticated") === "true");
    const [isInstructor, setIsInstructor] = useState(localStorage.getItem("isInstructor") === "true");
    const loginService = new LoginService();


    if (typeof window !== "undefined" && !window._fetchIntercepted) {
        console.log("✅ Global fetch interceptors tanımlanıyor...");

        window._fetchIntercepted = true;
        const originalFetch = window.fetch;
        window.fetch = async (...args) => {
            try {
                // let token = localStorage.getItem(AUTHORIZATION_HEADER);
                // if(token) {
                //     const decoded = jwtDecode(token);
                //     const now = Date.now() / 1000;
                //     const timeLeft = decoded.exp - now;
                //
                //     if (timeLeft <= 0) {
                //         onShowLoading(true, 'Oturum süreniz doldu, giriş ekranına yönlendiriliyorsunuz...');
                //
                //         setTimeout(() => {
                //             timeout();
                //             onHideLoading();
                //         }, 1500);
                //
                //         return Promise.reject("Token expired");
                //     }
                //
                //     if (timeLeft < 30) {
                //         loginService.refreshToken(token).then(response => {
                //             if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)
                //                 && GeneralUtils.isNullOrEmpty(response.error)) {
                //                 localStorage.setItem(AUTHORIZATION_HEADER, response.token);
                //                 console.log("✅ Token yenilendi: ", response.token);
                //             } else {
                //                 console.error("❌ Token yenileme başarısız: ");
                //             }
                //         });
                //     }
                // }


                const response = await originalFetch(...args);

                if (response.status === 401) {
                    onShowLoading(true,'Oturum süreniz doldu, giriş ekranına yönlendiriliyorsunuz...');

                    setTimeout(()=>{
                        timeout();
                        onHideLoading();
                    },1500);
                }

                return response;
            } catch (error) {
                console.log(error);
                onHideLoading();
                return Promise.reject(error);
            }
        };
    }

    // const router = useRouter();
    useEffect( () => {
        sal( { threshold: 0.1, once: true } );
    }, [window.location.href] );

    useEffect( () => {
        sal();
    }, [] );

    useEffect(() => {
        setIsAuthenticated(localStorage.getItem("isAuthenticated") === "true")
    }, [isAuthenticated]);

    useEffect(() => {
        setIsInstructor(localStorage.getItem("isInstructor") === "true")
    }, [isInstructor]);


    const logout = () => {
        let data = {eventType: "LOGOUT"};
        loginService.logout(data);
        localStorage.clear();
        setIsAuthenticated(false);
        setIsInstructor(false);
        window.location.href = "/";
        // window.location.reload();
    }

    const timeout = () => {
        let data = {eventType: "TIMEOUT"};
        loginService.logout(data);
        localStorage.clear();
        setIsAuthenticated(false);
        setIsInstructor(false);
        window.location.href = "/login";
        // window.location.reload();
    }

    // const browserRouter = (
//     <BrowserRouter>
//         <HeaderTest/>
//         <Routes>
//             <Route path="/" element={<HomeTest/>}/>
//             <Route path="/courseList" element={<CourseList/>}/>
//             <Route path="/course/:id" element={<CourseDetail/>}/>
//             <Route path="/dataViewDemo" element={<DataViewDemo/>}/>
//             <Route path="/showcase" element={<Showcase/>}/>
//         </Routes>
//     </BrowserRouter>
// );

    // const getLayout = (element) => {
    //     return <PrimeReactProvider>
    //             <LayoutProvider>
    //                 <Layout isAuthenticated={isAuthenticated} setIsAuthenticated={(isAuthenticated)=> setIsAuthenticated(isAuthenticated)}>
    //                     {element}
    //                 </Layout>
    //             </LayoutProvider>
    //         </PrimeReactProvider>
    // }

    const getLayout = ( children ) => {
        return <>
            <div className='sticky-header'>
                <div id="main-wrapper" className="main-wrapper">
                <Header isAuthenticated={isAuthenticated} isInstructor={isInstructor} logout={logout}/>
                {children}
                <Footer/>
                </div>
            </div>
        </>
    }

    const getInstructorLayout = ( children ) => {
        return <>
            <InstructorHeader logout={logout}/>
            {children}
            {/*<Copilot/>*/}
            <Footer/>
        </>
    }

    const browserRouter = (<BrowserRouter>
        <Routes>
            <Route path="/login" element={getLayout(<Login setIsAuthenticated={setIsAuthenticated} setIsInstructor={setIsInstructor}/>)}/>
            <Route path="/signup" element={getLayout(<Signup/>)}/>
            <Route path="/activation" element={getLayout(<Activation/>)}/>
            <Route path="//" element={getLayout(<Home/>)}/>
            <Route path="/courses" element={getLayout(<CategoryCourses/>)}>
                <Route path="/courses/:categoryId" element={getLayout(<CategoryCourses/>)}>
                    <Route path="/courses/:categoryId/:subcategoryId" element={getLayout(<CategoryCourses/>)}>
                        <Route path="/courses/:categoryId/:subcategoryId/:labelId" element={getLayout(<CategoryCourses/>)}/>
                    </Route>
                </Route>
            </Route>
            <Route path="/course/:id" element={getLayout(<Course/>)}/>
            <Route path="/user/myCourses" element={getLayout(<MyCourses/>)}/>
            <Route path="/user/profile" element={getLayout(<Profile/>)}/>
            <Route path="/instructorInfo/:instructorId" element={getLayout(<InstructorInfo/>)}/>

            <Route path="/chatGPT" element={getLayout(<ChatGPT/>)}/>
            <Route path="/aiPanelExample" element={getLayout(<AppAiPanelExample/>)}/>
            <Route path="/copilot" element={getLayout(<Copilot/>)}/> {/* Copilot route */}

            <Route path="/fileManager" element={getLayout(<FileManager/>)}/>

            <Route path="/course/view/:id" element={<CourseView/>}/>

            <Route path="/instructor" element={getInstructorLayout(<InstructorHome/>)}>
                <Route path="/instructor/courses" element={<InstructorCourses/>}/>
                <Route path="/instructor/createCourse" element={<CreateCourse/>}>
                    <Route path="/instructor/createCourse/:id" element={<CreateCourse/>}/>
                </Route>
                <Route path="/instructor/courses/:courseId/students" element={<CourseStudents/>}/>
            </Route>

        </Routes>
    </BrowserRouter>);


    return <>
        <MouseMoveProvider>
            {browserRouter}
        </MouseMoveProvider>
        <ScrollToTop />
        <ToastContainer
            theme="colored"
            position={toast.POSITION.TOP_CENTER}
        />
        <LoadingProvider/>
    </>;
}

export default App;
